import React, { Component } from 'react';
import { defineMessages } from 'react-intl';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import ReactTooltip from 'react-tooltip';
import _isNil from 'lodash/isNil';
import Isvg from 'react-inlinesvg';

import { intlMessage, opportunityPropType } from 'constants/propTypes';
import { ICONS } from 'constants/icons';
import Button from 'components/Button';
import { TodayTomorrowWeekday } from 'components/IntlHelpers';
import { SvgLoading } from 'components/Svgs';
import Message from 'components/Message';

import Bar from './Bar';
import './Opportunities.scss';

const messages = defineMessages({
  tooltip: {
    id: 'opportunies.opportunity.tooltip',
    defaultMessage: 'Hide recommendation',
  },
  dayAndTime: {
    id: 'opportunies.opportunity.day-and-time',
    defaultMessage: '{day}, {opportunityDate, date, time}',
  },
  xofyOverall: {
    id: 'opportunies.opportunity.xofy-overall',
    defaultMessage: '{totalReservations, number} of {totalCapacity, number} overall',
  },
});

class Opportunity extends Component {
  static propTypes = {
    actOnOpportunity: PropTypes.func,
    buttonMessage: intlMessage,
    derivedCapacity: PropTypes.number,
    idx: PropTypes.number.isRequired,
    isLoading: PropTypes.bool,
    isSuccess: PropTypes.bool,
    opportunity: opportunityPropType.isRequired,
    rejectOpportunity: PropTypes.func,
    xofyCPMessage: intlMessage,
  };

  static defaultProps = {
    isLoading: false,
    isSuccess: false,
    actOnOpportunity: () => {},
    rejectOpportunity: () => {},
  };

  constructor(props) {
    super(props);

    this.state = {
      shouldAnimate: false,
    };
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps(nextProps) {
    const { idx } = this.props;
    this.setState({
      shouldAnimate: idx - 1 === nextProps.idx,
    });
  }

  componentWillUnmount() {
    ReactTooltip.hide();
  }

  render() {
    const {
      actOnOpportunity,
      buttonMessage,
      derivedCapacity,
      isLoading,
      isSuccess,
      opportunity,
      rejectOpportunity,
      xofyCPMessage,
    } = this.props;
    const { shouldAnimate } = this.state;
    const {
      className,
      recommendation,
      scheduleDisabled,
      startDateTime,
      teacherName,
      totalCapacity,
      totalClasspassReservations,
      totalReservations,
      opportunitySource,
    } = opportunity;

    // TODO: SmartSpot opportunities don't support individual dismissal yet
    // Hotfix: Hide dismiss button for SS opportunities
    // Real solution: Backend should implement dismiss endpoint for SmartSpot opportunities (https://classpass.atlassian.net/browse/ST-8212)
    const canDismiss = opportunitySource !== 'SMARTSPOT';

    return (
      <div className={classNames('opportunity', { 'dismissal-anim-slide-left': shouldAnimate })}>
        <div className="opportunity__class-name">
          <span className="opportunity__class-name-wrap">{className}</span>
          {canDismiss && (
            <>
              <button
                type="button"
                className="opportunity__dismiss"
                onClick={rejectOpportunity}
                data-tip
                data-for="tooltip-opps-teaser-close">
                <Isvg src={ICONS.cross} />
              </button>
              <ReactTooltip id="tooltip-opps-teaser-close" place="left" effect="solid">
                <Message message={messages.tooltip} />
              </ReactTooltip>
            </>
          )}
        </div>
        <p className="opportunity__teacher-name">{teacherName}</p>
        <Message
          as="p"
          className="opportunity__start-time"
          message={messages.dayAndTime}
          values={{
            opportunityDate: startDateTime,
            day: <TodayTomorrowWeekday date={startDateTime} />,
          }}
        />
        <div className="opportunity__bar-container">
          <div className="opportunity__bar-group">
            <Bar reservations={totalClasspassReservations} capacity={derivedCapacity} isDisabled={scheduleDisabled} />
            <p className="opportunity__xofy">
              <Message message={xofyCPMessage} values={{ totalClasspassReservations, derivedCapacity }} />
            </p>
          </div>
          {!_isNil(totalReservations) && !_isNil(totalCapacity) && (
            <div className="opportunity__bar-group">
              <Bar reservations={totalReservations} capacity={totalCapacity} noColor />
              <p className="opportunity__xofy">
                <Message message={messages.xofyOverall} values={{ totalReservations, totalCapacity }} />
              </p>
            </div>
          )}
        </div>
        <div className="opportunity__recommendation">
          <Button className="opportunity__action" disabled={isLoading || isSuccess} onClick={actOnOpportunity}>
            {isLoading ? (
              <SvgLoading />
            ) : (
              <>
                {isSuccess && <Isvg uniquifyIDs={false} className="opportunity__action-icon" src={ICONS.checkmark} />}
                <Message message={buttonMessage} values={{ recommendation }} />
              </>
            )}
          </Button>
        </div>
      </div>
    );
  }
}

export default Opportunity;
